var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteFilterSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "6 6 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ei:close"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 114"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 46",
    cx: 16,
    cy: 16,
    r: 9.5,
    stroke: "#FFDCA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.485 11L21.0004 11.5154L11.5154 20.9996L11 20.4846L20.485 11Z",
    fill: "#FFDCA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.5154 11L21.0004 20.4842L20.485 21L11 11.5158L11.5154 11Z",
    fill: "#FFDCA8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFilterSvg);
export default __webpack_public_path__ + "static/media/DeleteFilterSVG.430aa1aae757b77879dfe72efd912d92.svg";
export { ForwardRef as ReactComponent };